import { isProvisionalIdentifier } from '../../util';

class DocumentThumbnailController {
  constructor(DocumentService, LogService) {
    "ngInject";
    this.DocumentService = DocumentService;
    this.LogService = LogService;
    this._constructed = true;
  }

  $onInit() {
  }

  set document(document) {
    this._document = document;
  }

  get document() {
    return this._document;
  }

  set maxsize(maxsize) {
    this._maxsize = maxsize;
  }

  get maxsize() {
    return this._maxsize;
  }

  get useFileDataURL() {
    return !!this.fileDataURL;
  }

  get useThumbnailURL() {
    return this.document
      && !this.useFileDataURL
      && !!this.thumbnailURL;
  }

  get fileDataURL() {
    return this.document && this.document.fileDataURL;
  }

  get thumbnailURL() {
    let url = null;
    if (this.document && this.document.id && !isProvisionalIdentifier(this.document.id)) {
      if (!this.DocumentService) {
        this.LogService.error("Attempting to show thumbnail URL when DocumentService has not been created");
      } else {
        let opts;
        if (this.maxsize) {
          opts = { maxsize: this.maxsize };
        }
        url = this.DocumentService.documentThumbnailURLForDocumentId(this.document.id, opts);
      }
    }
    return url;
  }

  get altText() {
    if(this.document){
      return this.document.title ?? this.document.name ?? this.document.id;
    }
  }
}

export default DocumentThumbnailController;
